import React from "react";
import { Box, Typography } from "@mui/material";
import { InsertDriveFile as FileIcon } from "@mui/icons-material";

const RoundBox = ({
  number = 0,
  showIcon = false,
  isChecked = false,
  width = 35,
  height = 35,
  border='none'
}) => {
  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        minWidth: `${width}px`, // <<< important
        minHeight: `${height}px`, // <<< important
        borderRadius: "50%", // Perfect Circle
        background: "linear-gradient(145deg, #7b42f6, #2c2c7c)",
        display: "flex",
         border:border,
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        color: "#fff",
        fontWeight: "bold",
        boxShadow: "inset 0 0 8px rgba(0,0,0,0.6)",
      }}
    >
      <Typography
        sx={{
          fontSize: "1rem",
          lineHeight: 1,
          zIndex: 2,
          pointerEvents: "none",
        }}
      >
        {number}
      </Typography>
      {isChecked &&
        showIcon && (
          <Box
            sx={{
              position: "absolute",
              top: "-8px", 
              right: "-7px", 
              zIndex: 3,
            }}
          >
            <span style={{ color: "green", fontSize:12 }}>✔</span>
          </Box>
        )}
      {showIcon && !isChecked && (
        <Box
          sx={{
            position: "absolute",
            bottom: "-2px", // <<< slightly out to look better
            right: "-2px",
            width: "14px",
            height: "14px",
            backgroundColor: "lime",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 3,
          }}
        >
          <FileIcon sx={{ fontSize: "10px", color: "#fff" }} />
        </Box>
      )}
    </Box>
  );
};

export default RoundBox;
